import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http'
import { Observable, of } from 'rxjs'
import { delay, mergeMap, materialize, dematerialize } from 'rxjs/operators'
import { environment } from '@env/environment'

@Injectable()
export class MockInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (environment.mock === true) {
      let tRequest: HttpRequest<any> = request
      /**
       * wrap in delayed observable to simulate server api call
       * call materialize and dematerialize to ensure delay even if an error is thrown
       * (https://github.com/Reactive-Extensions/RxJS/issues/648)
       */
      return of(null)
        .pipe(
          mergeMap(() => {
            if (
              request.url.endsWith('/traceabilities') &&
              request.method === 'POST'
            ) {
              tRequest = request.clone({
                url: 'assets/mock/traceabilities.json',
                method: 'GET'
              })
            }  else if (
              request.url.endsWith('/expeditions') &&
              request.method === 'POST'
            ) {
              tRequest = request.clone({
                url: 'assets/mock/expeditions.json',
                method: 'GET'
              })
            } else if (
              request.url.endsWith('/sites') &&
              request.method === 'GET'
            ) {
              tRequest = request.clone({
                url: 'assets/mock/sites.json',
                method: 'GET'
              })
            } else if (
              request.url.endsWith('/enums') &&
              request.method === 'GET'
            ) {
              tRequest = request.clone({
                url: 'assets/mock/enums.json',
                method: 'GET'
              })
            }

            // pass through any requests not handled above
            return next.handle(tRequest)
          })
        )
        .pipe(materialize())
        .pipe(delay(500))
        .pipe(dematerialize())
    } else {
      return next.handle(request)
    }
  }
}
